/**
 * The producer's derived "a secret is stored for this field" key, shared by the auth-provider API
 * module and the dev fixture. This module imports nothing, so the dev fixture can load it in plain
 * Node.
 */

/**
 * `has<Capitalised key>`: for example `clientSecret` gives `hasClientSecret`, as
 * `AuthProviderService.maskSecrets` in cp-auth-api writes it.
 */
export function hasSecretFlagKey(fieldKey: string): string {
  return `has${fieldKey.charAt(0).toUpperCase()}${fieldKey.slice(1)}`;
}
